import { divIcon } from "leaflet";

// CSS-drawn teardrop pin in the TraSaar blue (#0063a6, same as the footer).
// Uses a divIcon instead of an image asset so there are no licensing concerns
// and nothing extra to download per marker.
const companyMarkerIcon = divIcon({
  className: "company-marker",
  html: '<span class="company-marker__pin"></span>',
  iconSize: [42, 54],
  iconAnchor: [21, 52],
  popupAnchor: [0, -48],
});

export default companyMarkerIcon;
